import FJTextarea from '../../../../common/components/FJTextarea/FJTextarea';
import FJLocalStore from '../../../../store/FJLocalStore';
import styles from './FJObjectEraseTextPrompt.module.less';
import PropTypes from 'prop-types';

const FJObjectEraseTextPrompt = ({ textPrompt, onChangeTextPrompt }) => {
    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <span className={styles.title_text}>{FJLocalStore._('prompt')}</span>
                <span className={styles.count}>{textPrompt.length}/200</span>
            </div>
            <FJTextarea
                className={styles.textarea}
                maxLength={200}
                placeholder={FJLocalStore._('erase-object-placeholder')}
                value={textPrompt}
                onChange={onChangeTextPrompt}
            />
        </div>
    );
};

FJObjectEraseTextPrompt.propTypes = {
    textPrompt: PropTypes.string,
    onChangeTextPrompt: PropTypes.func,
};

export default FJObjectEraseTextPrompt;
